import { get } from 'vuex-pathify';

export default {
  computed: {
    attributesMetadata: get('layers/metadata@:currentLayerDataSourceName.attributes_schema.attributes'),
  },
  methods: {
    getHeaderName(label, unit) {
      return unit ? `${label} [${unit.symbol}]` : label;
    },
    getAttribute(attribute, attributesMetadata) {
      return attributesMetadata.find(att => att.name === attribute);
    },
    getSortedColumDefs() {
      const columnState = this.getColumnState();
      return this.sortColumns(
        columnState,
        this.getColumnDefs(columnState, this.currentLayer.form_schema.elements, this.attributesMetadata)
      );
    },
    getRelationalDict(attribute, datasource, representation) {
      return this.$store.get('attributesSchema/relationValuesMapping')[datasource]?.[attribute]?.[representation] || [];
    },
    getExpressionBuilderAttributes(elements, attributesMetadata) {
      const flattenLayerAttributes = this.$_flattenStructure(elements, 'elements');
      return flattenLayerAttributes.map(({ attribute, label }) => {
        const attributeMetadata = this.getAttribute(attribute, attributesMetadata);
        return { ...attributeMetadata, verbose_name: this.getHeaderName(label, attributeMetadata.measurement_unit) };
      });
    },
    getColumnDefs(columnState, elements, attributesMetadata) {
      return this.$_flattenStructure(elements, 'elements').map(({ label, attribute }) => {
        const {
          measurement_unit: unit,
          data_type: dataType,
          allowed_values: dictValues,
          allowed_relations: allowedRelations,
          dict_colors: dictColors,
          type,
          relation,
        } = this.getAttribute(attribute, attributesMetadata) || {};
        const isRelational = type === 'relation';
        const isRelationPointer = type === 'variable_relation_pointer';
        return {
          headerName: this.getHeaderName(label, unit),
          field: attribute,
          valueGetter: this.valueGetter,
          valueFormatter: this.valueFormatter,
          cellStyle: this.cellStyle,
          cellRendererSelector: this.getCellRendererHandler,
          resizable: true,
          width: columnState?.[attribute]?.width,
          dataType,
          dictColors,
          dictValues,
          isRelational: isRelational || isRelationPointer,
          relationalValues:
            (isRelational &&
              this.getRelationalDict(relation.attribute, relation.data_source, relation.representation)) ||
            (isRelationPointer &&
              allowedRelations.map(relation => {
                const { data_source, data_source_verbose_name } = relation;
                return { value: data_source, text: data_source_verbose_name };
              })),
        };
      });
    },
  },
};
